import { cx } from '../lib/cx';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Accessible name for the switch. */
  label: string;
  disabled?: boolean;
  className?: string;
}

/**
 * A toggle switch backed by a real checkbox with `role="switch"` (a11y §8.6.3) —
 * keyboard-operable, `aria-checked` announced, 24px hit area over the 32×18 track.
 */
export function Toggle({ checked, onChange, label, disabled = false, className }: ToggleProps): React.JSX.Element {
  return (
    <span className={cx('ds-toggle', className)}>
      <input
        type="checkbox"
        role="switch"
        className="ds-toggle__input"
        aria-label={label}
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          onChange(event.currentTarget.checked);
        }}
      />
      <span className="ds-toggle__track" aria-hidden="true">
        <span className="ds-toggle__knob" />
      </span>
    </span>
  );
}
